import React, { type ReactNode } from "react";
import { Text, Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { Tooltip } from "ui/tooltip";

type PlanProps = { price: string; description: string; list: ReactNode[] };

function StarterPlan({ price, description, list }: PlanProps) {
  return (
    <Flex direction={{ base: "row", sm: "column" }} justify="start" gap="smallest" borderRadius="small">
      <Box flex={1}>
        <Text textStyle="headline1" color="new.blue.700">
          {price}
        </Text>

        <Text textStyle="caption1" mt="tinier" fontWeight="semibold">
          {description}
        </Text>
      </Box>

      <SimpleGrid as="ul" flex={1} listStyleType="none" rowGap={{ base: 0, sm: "tinier" }}>
        {list.map((listItem: ReactNode, index) => (
          <Text key={index} as="li" textStyle="caption1">
            {listItem}
          </Text>
        ))}
      </SimpleGrid>
    </Flex>
  );
}

export function StarterCardDetails() {
  return (
    <Flex
      direction={{ base: "column", sm: "row" }}
      gap={{ base: "small", sm: "smaller", md: "bigger", lg: "smaller", xl: "bigger" }}
      justifyContent={{ base: "start", sm: "space-between", md: "start", lg: "space-between", xl: "start" }}
      wrap="wrap"
      mt="tiniest"
    >
      <StarterPlan
        price="$0"
        description="Free forever"
        list={[
          <Text key="destination" as="span">
            {getFormattedQuantity(1)} standard{" "}
            <Tooltip message="A destination is any tool or service you want to send source data to.">
              destination
            </Tooltip>
          </Text>,
          <React.Fragment key="workspace">{getFormattedQuantity(1)} workspace</React.Fragment>,
          <Text key="syncs" as="span">
            {getFormattedQuantity(2)} active{" "}
            <Tooltip message="A sync is the the process of querying data and sending it to a destination.">
              syncs
            </Tooltip>
          </Text>,
        ]}
      />

      <Box h={{ base: "1px", sm: "auto" }} w={{ base: "auto", sm: "1px" }} bg="brand.border.light" />

      <StarterPlan
        price="$350"
        description="Per month*"
        list={[
          <React.Fragment key="destinations">{getFormattedQuantity(2)} standard destinations</React.Fragment>,
          <React.Fragment key="workspaces">{getFormattedQuantity(2)} workspaces</React.Fragment>,
          <React.Fragment key="syncs">{getFormattedQuantity(5)} active syncs per destination</React.Fragment>,
        ]}
      />
    </Flex>
  );
}

function getFormattedQuantity(count: number) {
  return (
    <Text as="span" fontWeight="bold">
      {count}
    </Text>
  );
}
